<footer class="flex">
  <h4>A Splurky Vendor <br> Powered by Splurky</h4>
  <!-- <p>© 2022, Kellton Tech Private Limited</p> -->
</footer>